var map = {
	"./1/symbol_0.png": 6303,
	"./1/symbol_1.png": 26326,
	"./1/symbol_10.png": 20548,
	"./1/symbol_11.png": 46701,
	"./1/symbol_12.png": 56022,
	"./1/symbol_2.png": 7949,
	"./1/symbol_3.png": 51652,
	"./1/symbol_4.png": 33307,
	"./1/symbol_5.png": 35442,
	"./1/symbol_6.png": 26153,
	"./1/symbol_7.png": 71328,
	"./1/symbol_8.png": 15559,
	"./1/symbol_9.png": 97246,
	"./2/symbol_0.png": 63830,
	"./2/symbol_1.png": 41919,
	"./2/symbol_10.png": 57071,
	"./2/symbol_11.png": 18054,
	"./2/symbol_12.png": 99261,
	"./2/symbol_2.png": 28356,
	"./2/symbol_3.png": 76890,
	"./2/symbol_4.png": 72946,
	"./2/symbol_5.png": 38299,
	"./2/symbol_6.png": 83264,
	"./2/symbol_7.png": 38089,
	"./2/symbol_8.png": 39198,
	"./2/symbol_9.png": 10535,
	"./3/symbol_0.png": 88633,
	"./3/symbol_1.png": 91728,
	"./3/symbol_10.png": 82725,
	"./3/symbol_12.png": 41600,
	"./3/symbol_2.png": 61579,
	"./3/symbol_3.png": 40450,
	"./3/symbol_4.png": 36797,
	"./3/symbol_5.png": 15668,
	"./3/symbol_6.png": 34575,
	"./3/symbol_7.png": 95558,
	"./3/symbol_8.png": 51713,
	"./3/symbol_9.png": 67096,
	"./4/symbol_0.png": 1424,
	"./4/symbol_1.png": 91321,
	"./4/symbol_10.png": 80669,
	"./4/symbol_12.png": 22127,
	"./4/symbol_2.png": 24738,
	"./4/symbol_3.png": 15243,
	"./4/symbol_4.png": 65332,
	"./4/symbol_5.png": 86461,
	"./4/symbol_6.png": 88902,
	"./4/symbol_7.png": 70447,
	"./4/symbol_8.png": 95640,
	"./4/symbol_9.png": 39150,
	"./gold1.png": 57163,
	"./gold2.png": 85872,
	"./gold3.png": 92121,
	"./gold4.png": 42726,
	"./header_slotmachine_freespin._no_fg.png": 35922,
	"./silver1.png": 24792,
	"./silver2.png": 92928,
	"./silver3.png": 15338,
	"./silver4.png": 98565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92545;